import script from "./IconButton.vue?vue&type=script&setup=true&lang=js"
export * from "./IconButton.vue?vue&type=script&setup=true&lang=js"

import "./IconButton.vue?vue&type=style&index=0&id=8108f80e&lang=scss"

const __exports__ = script;

export default __exports__